import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PATreat } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_summary/PATreat';
import { Store } from '@ngrx/store';
import { AppLinkBuilder } from '../utils';
import { TreatmentType } from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/TreatmentType';

@Component({
  selector: 'pt-treatment-info-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{"LABELS.TREATMENTS" | translate}}
      </h4>
    </div>
    <div class='modal-body' style="max-height: 300px; overflow-y: auto">
      <div class="treatment" *ngFor="let treatment of treatmentInfo" (click)="openTreatment(treatment)">
        <pt-entity-icon *ngIf="treatment.type === 'HOLDER'" [entity]="'treatmentsHolder'" ></pt-entity-icon>
        <pt-entity-icon *ngIf="treatment.type === 'RESPONSIBLE'" [entity]="'treatmentsResponsible'" ></pt-entity-icon>
        <pt-entity-icon *ngIf="treatment.type === 'SUB_RESPONSIBLE'" [entity]="'treatmentsSubResponsible'"></pt-entity-icon>
        <pt-entity-icon *ngIf="treatment.type === 'PROJECT'" [entity]="'projectCards'"></pt-entity-icon>
        <div class="treatment-name text-link">{{treatment.name}}</div>
      </div>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false)'>
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .treatment {
      width: 100%;
      margin-bottom: 5px;
      /*border: 1px solid #33333333;*/
      /*border-radius: 5px;*/
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px;
    }
    .treatment pt-entity-icon {
      display: inline-flex;
      margin-right: 5px;
    }
    .treatment .treatment-name {
      display: inline-flex;
    }
  `]
})
export class TreatmentInfoDialogComponent {
  public treatmentInfo: PATreat[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store,
  ) {
  }


  run(treatmentInfo: PATreat[]): void {
    this.treatmentInfo = treatmentInfo;
  }

  openTreatment(treatment: PATreat) {
    switch (treatment.type) {
      case TreatmentType.SUB_RESPONSIBLE:
        window.open(AppLinkBuilder.linkOfEntity("treatmentsSubResponsible", treatment.id), '_blank');
        break;
      case TreatmentType.RESPONSIBLE:
        window.open(AppLinkBuilder.linkOfEntity("treatmentsResponsible", treatment.id), '_blank');
        break;
      case TreatmentType.HOLDER:
        window.open(AppLinkBuilder.linkOfEntity("treatmentsHolder", treatment.id), '_blank');
        break;
      case TreatmentType.PROJECT:
        window.open(AppLinkBuilder.linkOfEntity("projectCards", treatment.id), '_blank');
        break;
    }

  }
}
